<app-bookings-calendar
  [actives]="bookingService.actives"
  [historical]="bookingService.historical"
  [loading]="bookingService.loading"
  [neighborhoodId]="neighborhoodId">
</app-bookings-calendar>
